<template>
  <div>
    <!-- Search user -->
    <searchGroupWhitelist ref="searchGroupWhitelist" :selected="onSubmit" title="Search a group" />
    <!-- body -->
    <a-card :bordered="false" class="header-solid h-full">
      <!-- Title -->
      <template #title>
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="20">
            <h5 class="font-semibold m-0">Group Whitelist</h5>
          </a-col>
          <a-col :span="4">
            <div style="float: right">
              <a-button type="primary" shape="circle" icon="plus" @click="onSearch" />
            </div>
          </a-col>
        </a-row>
      </template>
      <!-- Body -->
      <a-table :columns="columns" :data-source="data" rowKey="_id">
        <template slot="action" slot-scope="row">
          <div style="float: right">
            <a-button type="danger" shape="circle" icon="delete" @click="onDelete(row)" />
          </div>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import axios from "axios";
import searchGroupWhitelist from "../../components/Search/SearchGroupWhitelist.vue";

export default {
  props: {},
  components: {
    searchGroupWhitelist
  },
  data() {
    return {
      query: "",
      data: [],
      columns: [
        {
          title: "Group",
          dataIndex: "groupName",
          scopedSlots: { customRender: "groupName" }
        },
        {
          title: "",
          dataIndex: "",
          scopedSlots: { customRender: "action" }
        }
      ],
      room: null
    };
  },
  //
  //
  //
  mounted() { },
  methods: {
    //
    //
    //
    setQuery(query) {
      this.query = query;
    },
    //
    //
    //
    setInfo(room) {
      this.room = room;
    },
    //
    //
    //
    requestData() {
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/rwl/groups/search?" + this.query, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: error.response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });
    },
    //
    //
    //
    onSearch() {
      this.$refs.searchGroupWhitelist.show();
    },
    //
    //
    //
    async onSubmit(data) {
      console.debug("data = ", data);
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/rwl/group",
          {
            roomId: this.room._id,
            roomName: this.room.name,
            userId: "",
            userEmail: "",
            groupId: data._id,
            groupName: data.name,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          if (response.data.success) {
            this.$notification.open({
              message: "Notification",
              description: "เรียบร้อย",
              icon: <a-icon type="check-circle" style="color: #00FF00" />
            });
            this.requestData();
          } else {
            this.$notification.open({
              message: "Notification",
              description: response.data.message,
              icon: <a-icon type="close-circle" style="color: #FF0000" />
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //
    // Delete data.
    //
    onDelete(item) {
      const self = this;
      this.$confirm({
        title: "ต้องการลบข้อมูลนี้หรือไม่?",
        onOk() {
          self.delete(item);
        },
        onCancel() { }
      });
    },
    //
    //
    //
    delete(item) {
      axios
        .delete(process.env.VUE_APP_INVENTORY_API + "/rwl/" + item._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.$notification.open({
            message: "Notification",
            description: "Completed",
            icon: <a-icon type="check-circle" style="color: #00FF00" />
          });
          this.requestData();
        })
        .catch(error => {
          this.$notification.open({
            message: "Notification",
            description: response.data.message,
            icon: <a-icon type="close-circle" style="color: #FF0000" />
          });
          return;
        });
    }
  }
};
</script>

<style lang="scss"></style>
